// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__70wN3","l1":"loader_l1__r17KX"};